<template>
  <object
    scroll="no"
    style="width: 100%; height: 100vh; overflow-x: hidden !important"
    scrolling="no"
    type="text/html"
    data="https://app.fabric.microsoft.com/view?r=eyJrIjoiNTY1YTQxYmUtNjZkOC00OWRkLWEzYmItMWNhNzc1N2I0NWUxIiwidCI6ImMzNmJlZGI5LTAwMzgtNDM0OC1iYzRjLTg4ZWQ4MWZjMTQ1OCIsImMiOjR9"
  ></object>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Desincorporacion",
  data() {
    return {};
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {
    if (!this.permissions.includes("Desincorporación"))
      this.$router.push("/dashboard");
  },
};
</script>

<style>
</style>
